enum IngestionFileType {
    Json = 'json',
    Csv = 'csv',
    Txt='txt'
}

export default IngestionFileType;
